import Divider from "@mui/material/Divider";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Typography from "@mui/material/Typography";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import LogoutIcon from "@mui/icons-material/Logout";
import Avatar from "@mui/material/Avatar";
import { ClickAwayListener } from "@mui/base";
import {
  StyledAvatar,
  StyledButton,
  StyledPaper,
} from "./SettingsDropDown.styles";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "store/auth/auth.slice";
import { useNavigate } from "react-router-dom";
import { persistor } from "store/store";

export function MainMenu({
  setOpenMenu,
  openMenu,
  openAdvancedSettings,
  setOpenAdvancedSettings,
  openSwitchAccounts,
  setOpenSwitchAccounts,
}: MainMenuProps) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  function handleSwitchAccounts() {
    setOpenSwitchAccounts(!openSwitchAccounts);
    setOpenMenu(!openMenu);
  }

  function handleLogout() {
    dispatch(logout());
    persistor.flush().then(() => navigate("/"));
  }

  function handleClose() {
    setOpenMenu(!openMenu);
  }

  function handleAdvancedSettings() {
    setOpenAdvancedSettings(!openAdvancedSettings);
    setOpenMenu(!openMenu);
  }

  function handleClickAway() {
    setOpenMenu(false);
  }
  const name = useSelector((state: any) => state.user.name);

  return (
    <>
      <ClickAwayListener onClickAway={handleClickAway}>
        <StyledPaper>
          <MenuList>
            <MenuItem>
              <Avatar style={{ marginRight: "10px" }} /> <b>{name}</b>
            </MenuItem>
            <MenuItem sx={{ cursor: "auto" }}>
              <StyledButton onClick={handleClose}>View profile</StyledButton>
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleSwitchAccounts}>
              <StyledAvatar />
              <span style={{ fontSize: ".9rem" }}>Switch accounts</span>
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleClose}>
              <ListItemIcon>
                <PersonOutlineIcon htmlColor="#000000" />
              </ListItemIcon>
              <ListItemText>
                <b>Account</b>
              </ListItemText>
            </MenuItem>
            {/* <MenuItem onClick={handleClose}>
              <ListItemIcon></ListItemIcon>
              <ListItemText>Settings and privacy</ListItemText>
              <Typography variant="body2" color="text.secondary">
                <KeyboardArrowRightIcon htmlColor="#000000" />
              </Typography>
            </MenuItem> */}
            <MenuItem onClick={handleClose}>
              <ListItemIcon></ListItemIcon>
              <ListItemText>Help and support</ListItemText>
              <Typography variant="body2" color="text.secondary">
                <KeyboardArrowRightIcon htmlColor="#000000" />
              </Typography>
            </MenuItem>
            <MenuItem onClick={handleAdvancedSettings}>
              <ListItemIcon></ListItemIcon>
              <ListItemText>Advanced settings</ListItemText>
              <Typography variant="body2" color="text.secondary">
                <KeyboardArrowRightIcon htmlColor="#000000" />
              </Typography>
            </MenuItem>
            {/* <MenuItem onClick={handleClose}>
              <ListItemIcon></ListItemIcon>
              <ListItemText>Language</ListItemText>
              <Typography variant="body2" color="text.secondary">
                <KeyboardArrowRightIcon htmlColor="#000000" />
              </Typography>
            </MenuItem> 
            <MenuItem onClick={handleClose}>
              <ListItemIcon></ListItemIcon>
              <ListItemText>Give feedback</ListItemText>
              <Typography variant="body2" color="text.secondary"></Typography>
            </MenuItem> */}
            {/* <Divider />
            <MenuItem onClick={handleClose}>
              <ListItemIcon>
                <RemoveRedEyeIcon htmlColor="#000000" />
              </ListItemIcon>
              <ListItemText>
                <b>Display</b>
              </ListItemText>
            </MenuItem>
            <MenuItem onClick={handleClose}>
              <ListItemIcon></ListItemIcon>
              <ListItemText>Accessibility</ListItemText>
              <Typography variant="body2" color="text.secondary">
                <KeyboardArrowRightIcon htmlColor="#000000" />
              </Typography>
            </MenuItem>
            <MenuItem onClick={handleClose}>
              <ListItemIcon></ListItemIcon>
              <ListItemText>Dark mode</ListItemText>
              <Typography variant="body2" color="text.secondary">
                <ToggleOnIcon />
              </Typography>
            </MenuItem> */}
            <Divider />
            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <LogoutIcon htmlColor="#000000" />
              </ListItemIcon>
              <ListItemText>
                <b>Sign out</b>
              </ListItemText>
            </MenuItem>
          </MenuList>
        </StyledPaper>
      </ClickAwayListener>
    </>
  );
}
